import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'card-checkout-green',
    templateUrl: './card-checkout-green.component.html',
    styleUrls: ['./card-checkout-green.component.scss']
})
export class CardCheckoutGreenComponent implements OnInit {

    @Input() checkoutUrl!: string;
    @Input() metadadosGreen: any;

    constructor() { }

    ngOnInit(): void {
    }

    irParaCheckout() {
        window.open(this.checkoutUrl, '_blank');
    }
}
